// Timestamps render in the viewer's own time zone (whatever the browser reports).
const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

// Letter abbreviations are split across locales in CLDR: en-US has them for US
// zones (EDT, PST), en-GB for European ones (EEST, CET). We try both and take
// the first that yields letters, falling back to en-US's numeric offset (GMT+9)
// for zones that have no abbreviation in either.
const ZONE_FORMATTERS = ['en-US', 'en-GB'].map(
  (locale) => new Intl.DateTimeFormat(locale, { timeZoneName: 'short' }),
);

function formatZoneName(date) {
  let offsetLabel = '';

  for (const formatter of ZONE_FORMATTERS) {
    const zoneName = formatter
      .formatToParts(date)
      .find((part) => part.type === 'timeZoneName')?.value;

    if (!zoneName) continue;
    if (!/^(GMT|UTC)/.test(zoneName)) return zoneName;
    offsetLabel ||= zoneName;
  }

  return offsetLabel;
}

export function formatDateTimeLabel(isoString) {
  if (isoString == null || isoString === '') return '';
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '';

  const zoneName = formatZoneName(d);
  const dateTime = DATE_TIME_FORMATTER.format(d);
  return zoneName ? `${dateTime} ${zoneName}` : dateTime;
}
